import {
    Background,
    BackgroundColor,
    Spacer,
    SpacerVariant,
    backgroundGreyScaleColorsOptions,
    spacerOptionsAll,
} from "../components/layout"
import ImageEditor, { AspectRatio } from "../Image"
import Typography, { TypographyElement } from "../Typography"

import { Color } from "../components/typography"
import { IconText } from "../components/icon-text"
import { Pictograms } from "../../types"
import React from "react"
import { types } from "react-bricks/frontend"

interface QuoteCompactProps {
    background: { color: BackgroundColor } | BackgroundColor
    quote: TypographyElement[]
    author: TypographyElement[]
    spacerTop?: SpacerVariant
    spacerBottom?: SpacerVariant
}

const QuoteCompact: types.Brick<QuoteCompactProps> = ({ background, spacerTop, spacerBottom }) => {
    const bgColor = typeof background === "object" ? background.color : background
    return (
        <Background color={bgColor}>
            <Spacer variant={spacerTop} />
            <div className="mx-auto w-full px-15 sm:box-content sm:max-w-[500px] lg:max-w-[700px]">
                <IconText
                    icon={Pictograms.quote_outline}
                    className="-ml-5 mb-3 sm:-ml-[34px] lg:-ml-[45px] lg:mb-3.5"
                />
                <Color>
                    <Typography block="copytext-quote" allowList={["sup", "link", "italic"]} propName="quote" />
                    <div className="mt-7 flex items-center sm:mt-10">
                        <ImageEditor
                            aspectRatio={AspectRatio["1/1"]}
                            maxWidth={90}
                            className="mr-3.5 h-15 w-15 rounded-full sm:mr-5 sm:h-[70px] sm:w-[70px] lg:mr-6 lg:h-[90px] lg:w-[90px]"
                            propName="authorImage"
                        />
                        <Typography allowList={["bold"]} propName="author" />
                    </div>
                </Color>
            </div>
            <Spacer variant={spacerBottom} />
        </Background>
    )
}

QuoteCompact.schema = {
    name: "QuoteCompact",
    label: "Quote Compact",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/QuoteCompact.png`,
    sideEditProps: [
        {
            name: "background",
            label: "Background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                display: types.OptionsDisplay.Color,
                options: backgroundGreyScaleColorsOptions,
            },
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
            ],
        },
    ],
    getDefaultProps: (): QuoteCompactProps => ({
        background: { color: BackgroundColor.White },
        quote: [
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                        italic: true,
                    },
                ],
            },
        ],
        author: [
            {
                type: "paragraph",
                children: [
                    {
                        bold: true,
                        text: "Lorem ipsum",
                    },
                    {
                        text: " dolor sit amet",
                    },
                ],
            },
        ],
        spacerTop: SpacerVariant.Medium,
        spacerBottom: SpacerVariant.Medium,
    }),
}

export default QuoteCompact
